
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import UploadImg from '@/common/class/UploadImg'
import commonService from '@/services/common-service'

@Component({})
export default class MediaCircle extends Vue {
    private appImgFile: File | undefined | null = null
    private pcImgFile: File | undefined | null = null
    private uploadEl?: HTMLElement
    private mediaCircleForm: any = { 
        pc_img: '', 
        app_img: '',
        title: '', 
        url: '', 
        order: '' 
    }
    private mediaCircleMediaRules = {
        pc_img: [
            { required: true, validator: this.pcImgValidator }
        ],
        app_img: [
            { required: true, validator: this.appImgValidator }
        ],
        title: [
            { required: true, message: '请输入标题' }
        ],
        url: [
            { required: true, validator: this.urlValidtor }
        ],
        order: [
            { required: true, validator: this.orderValidtor }
        ]
    }
    private isLoading = false
    private loadingMsg = ''
    private pcUploadedImgUrl = ''
    private pcPreviewSrc = ''
    private appPreviewSrc = ''
    private appUploadedImgUrl = ''
    private imgLoad = false
    private copy: any = ''

    private get pcFile() {
        return (this.$refs.pcFile as HTMLElement)
    }

    private get appFile() {
        return (this.$refs.appFile as HTMLElement)
    }

    private pcImgValidator(rule: any, value: any, callback: Function) {
        if (this.mediaCircleForm.img) callback()
        if (!this.pcImgFile) {
            return callback('请选择上传图片')
        }
        callback()
    }

    private appImgValidator(rule: any, value: any, callback: Function) {
        if (this.mediaCircleForm.img) callback()
        if (!this.appImgFile) {
            return callback('请选择上传图片')
        }
        callback()
    }

    private urlValidtor(rule: any, value: any, callback: Function) {
        let message = '请输入正确的链接地址'
        if (!value) return callback(message)
        let reg = /^(?:(http|https|ftp):\/\/)?((?:[\w-]+\.)+[a-z0-9]+)((?:\/[^/?#]*)+)?(\?[^#]+)?(#.+)?$/i
        if (!reg.test(value)) {
            return callback(message)
        }
        callback()
    }

    private orderValidtor(rule: any, value: any, callback: Function) {
        let message = '请输入正确的序号'
        // 检验是否 number 类型
        const isNumber = Number.isInteger(+value)
        if (!isNumber) {
            return callback(message)
        }
        callback()
    }

    private mounted() {
        this.initData()
    }

    private get formRef() {
        return (this.$refs.mediaCircleForm as ElForm)
    }

    private async initData() {
        const { id } = this.$route.params
        this.showLoading('获取数据中')
        const result = await commonService.getMediaDetail({ id: +id })
        this.hideLoading()
        if (result.status === 200) {
            this.mediaCircleForm = result.data
            this.pcUploadedImgUrl = result.data.img
            this.appUploadedImgUrl = result.data.app_img
            this.copy = JSON.stringify(result.data)
        }
    }

    private async uploadPcImg() {
        // 上传图片
        if (!this.pcImgFile) { 
            this.$message({ type: 'warning', message: '发生错误, 请稍后再试' })    
            return false
        }
        const uploadImg = new UploadImg(this.pcImgFile)
        this.showLoading('上传 PC 图片中')
        const uploadImgRes: any = await uploadImg.upload()
        if (uploadImgRes.error) {
            this.$message({ 
                type: 'warning', 
                message: 'PC 图片上传失败, 请稍后再试'
            })
            return false
        }
        return uploadImgRes.key
    }

    private async uploadAppImg() {
        // 上传图片
        if (!this.appImgFile) { 
            this.$message({ type: 'warning', message: '发生错误, 请稍后再试' })    
            return false
        }
        const uploadImg = new UploadImg(this.appImgFile)
        this.showLoading('上传 APP 图片中')
        const uploadImgRes: any = await uploadImg.upload()
        if (uploadImgRes.error) {
            this.$message({ 
                type: 'warning', 
                message: 'APP 图片上传失败, 请稍后再试'
            })
            return false
        }
        return uploadImgRes.key
    }

    private showLoading(msg = '') {
        if (msg) {
            this.loadingMsg = msg
        }
        this.isLoading = true
    }

    private hideLoading() {
        this.isLoading = false
    }

    private onPcFileChange(e: Event) {
        const file = (e.target as any).files[0] 
        this.pcImgFile = file
        this.pcPreviewSrc = URL.createObjectURL(file)
        this.mediaCircleForm.pc_img = this.pcPreviewSrc
        this.formRef.validateField('pc_img')
    }

    private onAppFileChange(e: Event) {
        const file = (e.target as any).files[0] 
        this.appImgFile = file
        this.appPreviewSrc = URL.createObjectURL(file)
        this.mediaCircleForm.app_img = this.appPreviewSrc
        this.formRef.validateField('app_img')
    }

    private onPCFileSelect() {
        this.pcFile.click()
    }

    private onAppFileSelect() {
        this.appFile.click()
    }

    private onSubmitForm() {
        // 校验， 通过上传图片
        this.formRef && this.formRef.validate(async (isValid: boolean) => {
            if (!isValid) {
                return
            }

            const isUpdate = this._hasUpdate()
            if (!isUpdate) {
                return this.$message({ 
                    type: 'warning', 
                    message: '请修改后再保存' 
                })
            }

            if (this.pcImgFile) {
                const key = await this.uploadPcImg()
                if (!key) {
                    return this.$message({ 
                        type: 'warning', 
                        message: '上传图片发生错误, 请稍后再试' 
                    })
                }
                this.mediaCircleForm.pc_img = key
            }

            if (this.appImgFile) {
                const key = await this.uploadAppImg()
                if (!key) {
                    return this.$message({ 
                        type: 'warning', 
                        message: '上传图片发生错误, 请稍后再试' 
                    })
                }
                this.mediaCircleForm.app_img = key
            }

            this.showLoading('更新媒体圈中')
            Object.assign(this.mediaCircleForm, {
                img: this.mediaCircleForm.pc_img
            })
            const result = await commonService.updateMediaCircle(this.mediaCircleForm)
            this.hideLoading()
            if (result.status === 200) {
                this.$message({
                    message: '更新成功',
                    type: 'success'
                })
            }
        })
    }

    private _hasUpdate() {
        const originForm = JSON.parse(this.copy)
        for (let key in originForm) {
            if (originForm[key] !== this.mediaCircleForm[key]) {
                return true
            }
        }
        return false
    }
}
